// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1HEgr","description":"styles_description__PrjXL"};